class ProductCollapsibleTabs extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (!this.triggers.length || !this.panels.length) return;

    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => this.activateTab(index));
      trigger.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activateTab(index) {
    this.triggers.forEach((trigger, i) => {
      const isActive = i === index;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      trigger.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  onKeydown(event, index) {
    let nextIndex = index;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (index + 1) % this.triggers.length;
        break;
      case 'ArrowLeft':
        nextIndex = (index - 1 + this.triggers.length) % this.triggers.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.triggers.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activateTab(nextIndex);
    this.triggers[nextIndex].focus();
  }
}

if (!customElements.get('product-collapsible-tabs')) {
  customElements.define('product-collapsible-tabs', ProductCollapsibleTabs);
}
